import React from 'react';


const programSections = [
    {
        title: "Процедуры", // Заголовок верхнего уровня
        type: "category", // Добавим тип для дифференциации
        subItems: [ // Теперь это массив под-элементов/подкатегорий
            {
                title: "Грязелечение",
                description: "Применение лечебных грязей для терапии различных заболеваний. Способствует уменьшению воспалений и улучшению обмена веществ.",
                imageUrl: "/Assets/Procedure/1.jpg", // Упрощено
            },
            {
                title: "Аэрогидромассаж",
                description: "Процедура с использованием струй воды и воздуха для расслабления и оздоровления. Повышает тонус кожи, улучшает кровообращение.",
                imageUrl: "/Assets/Procedure/2.jpg", // Упрощено
            },
            {
                title: "Криотерапия",
                description: "Лечение холодом, способствующее активации иммунной системы и уменьшению болевых ощущений.",
                imageUrl: "/Assets/Procedure/3.jpg", // Упрощено
            },
            {
                title: "Ударно-волновая терапия",
                description: "Неинвазивный метод лечения с использованием акустических волн. Эффективна при заболеваниях опорно-двигательного аппарата.",
                imageUrl: "/Assets/Procedure/4.jpg", // Упрощено
            },
            {
                title: "Ванна сухая углекислая",
                description: "Процедура, улучшающая кровообращение и общее состояние организма за счет воздействия углекислого газа.",
                imageUrl: "/Assets/Procedure/5.jpg", // Упрощено
            },
            {
                title: "Подводный душ массаж",
                description: "Массаж тела под водой с использованием направленных струй. Способствует расслаблению мышц и уменьшению целлюлита.",
                imageUrl: "/Assets/Procedure/6.jpg", // Упрощено
            },
            {
                title: "Минеральные ванны",
                description: "Лечебные ванны с использованием природных минеральных вод. Обладают оздоровительным и расслабляющим эффектом.",
                imageUrl: "/Assets/Procedure/7.jpg", // Упрощено
            },
            {
                title: "Массаж в санатории",
                description: "Различные виды лечебного и расслабляющего массажа, проводимые квалифицированными специалистами санатория.",
                imageUrl: "/Assets/Procedure/8.jpg", // Упрощено
            },
            {
                title: "Солодковые ванны",
                description: "Ванны с отваром корня солодки, обладающие противовоспалительным и успокаивающим действием.",
                imageUrl: "/Assets/Procedure/9.jpg", // Упрощено
            },
            {
                title: "Спелеотерапия",
                description: "Лечение в условиях микроклимата соляных пещер. Помогает при заболеваниях дыхательной системы и аллергии.",
                imageUrl: "/Assets/Procedure/10.jpg", // Упрощено
            },
        ]
    },
    {
        title: "Специальные программы", // Заголовок верхнего уровня
        type: "category",
        subItems: [ // Массив под-элементов/программ
            {
                title: "Снижение веса",
                description: "Комплексная программа, направленная на безопасное и эффективное снижение веса под контролем специалистов.",
                imageUrl: "/Assets/Programs/1.webp", // Упрощено
            },
            {
                title: "Урология",
                description: "Программа для профилактики и лечения урологических заболеваний. Включает консультации специалистов и необходимые процедуры.",
                imageUrl: "/Assets/Programs/2.webp", // Упрощено
            },
            {
                title: "Гинекология",
                description: "Специализированная программа для женского здоровья, включающая диагностику и лечение гинекологических проблем.",
                imageUrl: "/Assets/Programs/3.webp", // Упрощено
            },
            {
                title: "Антистресс",
                description: "Программа для борьбы со стрессом, восстановления нервной системы и улучшения психоэмоционального состояния.",
                imageUrl: "/Assets/Programs/4.jpeg", // Упрощено
            },
            {
                title: "Лечебное плавание",
                description: "Занятия плаванием в лечебных целях. Способствует укреплению мышц, улучшению работы суставов и общему оздоровлению.",
                imageUrl: "/Assets/Programs/5.jpeg", //
            },
            {
                title: "Базовая",
                description: "Комплексная оздоровительная программа, направленная на общее укрепление организма.",
                imageUrl: "/Assets/Programs/6.jpeg", // Упрощено
            },
            {
                title: "Базовая премиум",
                description: "Расширенная версия базовой программы с дополнительными процедурами и услугами повышенного комфорта.",
                imageUrl: "/Assets/Programs/7.jpeg", // Упрощено
            },
            {
                title: "Детокс",
                description: "Программа очищения организма от шлаков и токсинов, восстановление обмена веществ.",
                imageUrl: "/Assets/Programs/8.jpg", // Упрощено
            },
            {
                title: "Крепкий иммунитет",
                description: "Программа для повышения защитных сил организма, профилактика простудных и инфекционных заболеваний.",
                imageUrl: "/Assets/Programs/9.jpg", // Упрощено
            }
        ]
    },
];


const TreatmentPage = () => {
    return (
        <div className="treatment-page-container">
            <header className="page-header">
                <h1>Программы и Процедуры Санатория "Джинал"</h1>
            </header>

            <div className="sections-wrapper">
                {programSections.map((section, sectionIndex) => (
                    <section className={`treatment-section ${sectionIndex === 0 ? 'first-section' : ''}`} key={sectionIndex}>
                        <h2 className="treatment-section-title">{section.title}</h2>

                        <div className="treatment-cards-list">
                            {section.subItems.map((item, itemIndex) => (
                                <div className="treatment-card" key={itemIndex}>
                                    <div className="treatment-card-content">
                                        <div className="treatment-card-banner">
                                            {item.title}
                                        </div>
                                        <h3 className="treatment-item-title">{item.title}</h3>
                                        <p className="treatment-item-description">{item.description}</p>
                                    </div>
                                    <div className="treatment-card-image-container">
                                        {item.imageUrl && <img src={item.imageUrl} alt={item.title} className="treatment-card-image"/>}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>
                ))}
            </div>
        </div>
    );
};

export default TreatmentPage;